import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

const ConfirmLeaveCreditOffer = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'ConfirmLeaveCreditOffer' });

  return (
    <Modal title={t('title')}>
      <p>{t('body')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default ConfirmLeaveCreditOffer;
